import { useNavigate } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { FileText, FolderOpen, Image, Link2 } from "lucide-react";

const dashboardItems = [
  {
    title: "ACCOUNTS",
    description: "Manage .txt account files",
    icon: FileText,
    path: "/admin-5390214552274/dashboard/accounts",
    color: "#22c55e",
  },
  {
    title: "DOCUMENTS",
    description: "Manage documents & files",
    icon: FolderOpen,
    path: "/admin-5390214552274/dashboard/documents",
    color: "#06b6d4",
  },
  {
    title: "GALLERY",
    description: "Manage images & videos",
    icon: Image,
    path: "/admin-5390214552274/dashboard/gallery",
    color: "#a855f7",
  },
  {
    title: "PAGES",
    description: "Manage external links",
    icon: Link2,
    path: "/admin-5390214552274/dashboard/pages",
    color: "#f59e0b",
  },
];

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <AdminLayout title="DASHBOARD">
      <div className="p-4 md:p-6" data-testid="dashboard">
        {/* Header */}
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl text-[#22c55e] text-glow font-['VT323']">
            [ CONTROL PANEL ]
          </h2>
          <p className="text-[#4ade80] text-sm mt-2">
            Select a section to manage
          </p>
        </div>

        {/* Dashboard Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {dashboardItems.map((item) => (
            <button
              key={item.title}
              onClick={() => navigate(item.path)}
              className="p-6 bg-[#0a0a0a] border border-[#15803d] hover:border-current transition-colors text-left group card-glow"
              style={{ "--tw-border-opacity": 1 }}
              data-testid={`dashboard-${item.title.toLowerCase()}`}
            >
              <div
                className="w-12 h-12 flex items-center justify-center mb-4 border"
                style={{ borderColor: item.color, color: item.color }}
              >
                <item.icon size={24} />
              </div>
              <h3
                className="text-lg font-['VT323'] tracking-wider mb-2"
                style={{ color: item.color }}
              >
                [ {item.title} ]
              </h3>
              <p className="text-[#4ade80] text-sm opacity-70">
                {item.description}
              </p>
            </button>
          ))}
        </div>

        {/* System Status */}
        <div className="mt-8 p-4 bg-[#0a0a0a] border border-[#15803d]">
          <h3 className="text-[#06b6d4] font-['VT323'] text-lg mb-4">
            [ SYSTEM STATUS ]
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <span className="text-[#4ade80] opacity-60">STATUS:</span>
              <span className="ml-2 text-[#22c55e]">ONLINE</span>
            </div>
            <div>
              <span className="text-[#4ade80] opacity-60">UPTIME:</span>
              <span className="ml-2 text-[#22c55e]">99.9%</span>
            </div>
            <div>
              <span className="text-[#4ade80] opacity-60">SECURITY:</span>
              <span className="ml-2 text-[#22c55e]">ACTIVE</span>
            </div>
            <div>
              <span className="text-[#4ade80] opacity-60">VERSION:</span>
              <span className="ml-2 text-[#22c55e]">1.0.0</span>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
